/*******************************************************************************
RETURN THE BREAKPOINT DATA
Pairs with /frontend/sass/misc/_breakpoint-detect.scss
See here for why this is needed: https://www.fourfront.us/blog/jquery-window-width-and-media-queries
And this for the implementation: https://www.lullabot.com/articles/importing-css-breakpoints-into-javascript
*******************************************************************************/

export default function getBreakpointData() {
    const breakpointData = window.getComputedStyle(document.querySelector('.logo-bar'), ':before').getPropertyValue('content').replace(/['"]+/g, '').split('|', 2);

    const breakpointOrder = (breakpointData[1] || '').split(',');
    breakpointOrder.unshift('xxs');

    const currentBreakpoint = breakpointData[0] || '';
    const currentIndex = breakpointOrder.findIndex(bp => bp === currentBreakpoint);

    return {
        current: currentBreakpoint,
        currentIndex,
        order  : breakpointOrder,
    };
}
